/**
 * @author bly
 * 功能-丛套书
 */
import { Service } from '@/tools'

export class SeriesService<T extends TCommodity.Series> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TCommodity.Series}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 丛套书
   * /api/commodity/series/v1/selectCommoditySeriesBySkuCode
   */
  selectCommoditySeriesBySkuCode = <K extends T['ApiSelectCommoditySeriesBySkuCode']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiSelectCommoditySeriesBySkuCode', data)
}
